import { Component } from '@angular/core';
import { INotRespond, ServerNotRespondingService } from '@services/server-not-responding.service';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Component({
  selector: 'cd-server-not-responding',
  templateUrl: './server-not-responding.component.html',
  styleUrls: ['./server-not-responding.component.scss'],
})
export class ServerNotRespondingComponent {
  readonly staticUrl = environment.staticUrl;

  serverNotResponding$: Observable<INotRespond | null>;

  constructor(private serverNotRespondingService: ServerNotRespondingService) {
    this.serverNotResponding$  = this.serverNotRespondingService.hasError$;
  }

  refresh(): void {
    window.location.reload();
  }
}
